import { FIND_ASSIGNABLE_ROUTINES, SortDirectionEnum } from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutineColumns } from './useRoutineColumns';

export type EditGroupRoutinesListProps = {
  workspace: any;
  groupId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditGroupRoutinesList = ({
  workspace,
  groupId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditGroupRoutinesListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspace?.id) {
      return {
        keyword,
        groupId,
        assignments,
        workspaceId: workspace?.id,
      };
    }
    return undefined;
  });
  const columns = useRoutineColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({
      keyword,
      groupId,
      assignments,
      workspaceId: workspace?.id,
    });
  }, [keyword, groupId, workspace]);

  if (!filter) return null;

  return (
    <AssignmentListGrid
      modelName="routine"
      query={FIND_ASSIGNABLE_ROUTINES}
      dataPrefix="group.findAssignableRoutines"
      columns={columns}
      filter={filter}
      assignments={assignments}
      onAssignmentsChange={updateAssignments}
      maxHeight={maxHeight}
      textEmpty={t('routines.textEmpty')}
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
      // Routine ids can arrive as numbers from the server; normalise so
      // membership matches the string assignment list.
      getRowId={(row) => String(row.id)}
    />
  );
};
